export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';

export function trySelectLanguage(language_id) {
  return { 
    type: UPDATE_LANGUAGE,
    language_id
  };
};